import { Component } from '@angular/core';

@Component({
  selector: 'evs-page-401',
  templateUrl: './page-401-template.html',
  styleUrls: ['./style.css'],
})
export class Page401Component {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/page-error/page-401-component.ts